import { SearchFilters } from '@/types/library';

export interface CatalogueState {
  searchQuery: string;
  filters: SearchFilters;
  page: number;
  pageSize: number;
  viewMode: 'grid' | 'list';
}

/**
 * Parse URL search parameters into catalogue state
 */
export function parseQueryParams(searchParams: URLSearchParams): CatalogueState {
  return {
    searchQuery: searchParams.get('q') || '',
    filters: {
      author: searchParams.get('author') || undefined,
      subject: searchParams.get('subject') || undefined,
      year_from: searchParams.get('year_from') ? Number(searchParams.get('year_from')) : undefined,
      year_to: searchParams.get('year_to') ? Number(searchParams.get('year_to')) : undefined,
      availability: (searchParams.get('availability') as any) || undefined,
      language: searchParams.get('language') || undefined,
    },
    page: Number(searchParams.get('page')) || 1,
    pageSize: Number(searchParams.get('page_size')) || 9,
    viewMode: (searchParams.get('view') as 'grid' | 'list') || 'grid',
  };
}

/**
 * Build URL search parameters from catalogue state
 */
export function buildQueryParams(state: CatalogueState): Record<string, string> {
  const params: Record<string, string> = {};
  
  if (state.searchQuery) params.q = state.searchQuery;
  if (state.filters.author) params.author = state.filters.author;
  if (state.filters.subject) params.subject = state.filters.subject;
  if (state.filters.year_from) params.year_from = String(state.filters.year_from);
  if (state.filters.year_to) params.year_to = String(state.filters.year_to);
  if (state.filters.availability) params.availability = state.filters.availability;
  if (state.filters.language) params.language = state.filters.language;
  if (state.page > 1) params.page = String(state.page);
  if (state.pageSize !== 9) params.page_size = String(state.pageSize);
  if (state.viewMode !== 'grid') params.view = state.viewMode;
  
  return params;
}

/**
 * Create a default/empty catalogue state
 */
export function createDefaultState(): CatalogueState {
  return {
    searchQuery: '',
    filters: {},
    page: 1,
    pageSize: 9,
    viewMode: 'grid',
  };
}
